import React, { Component, PropTypes } from 'react';
import {Button} from 'react-bootstrap';
import {connect} from 'react-redux';

export default class MatchesControl extends Component{
  render() {
    return(
      <div className="controls">
        <Button bsStyle="info" disabled={this.props.isUpdating} onClick={this.props.initialize}>
          Refresh
        </Button>

        <Button bsStyle="primary" onClick={this.props.updateMatchesRequested} disabled={this.props.isMatching}>
          { this.props.isMatching ? 'Running...' : 'Run Matching' }
        </Button>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/matches/Control.jsx